import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import CapabilitiesPage from "@/pages/CapabilitiesPage";
import ProcessPage from "@/pages/ProcessPage";
import GlobalPresencePage from "@/pages/GlobalPresencePage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import BlogPostPage from "@/pages/BlogPostPage";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/*" element={<AdminDashboardPage />} />
        <Route path="/*" element={
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/capabilities" element={<CapabilitiesPage />} />
                <Route path="/process" element={<ProcessPage />} />
                <Route path="/global-presence" element={<GlobalPresencePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/blog/:postId" element={<BlogPostPage />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
          </div>
        } />
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
